import React, { useEffect } from 'react';

const Toast = ({ message, type, duration = 3000, onClose }) => {

  useEffect(() => {
    //console.log('duration:', duration);
    const timer = setTimeout(() => {
      onClose(); // Automatically close after `duration`
    }, duration);

    return () => clearTimeout(timer); // Cleanup the timer on component unmount
  }, [duration, onClose]);

  const getToastStyle = () => {
    switch (type) {
      case 'success':
        return { backgroundColor: '#4caf50', color: '#fff' };
      case 'error':
        return { backgroundColor: '#f44336', color: '#fff' };
      case 'warning':
        return { backgroundColor: '#f1b44c', color: '#fff' };
      default:
        return { backgroundColor: '#333', color: '#fff' };
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: '1rem',
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 9999,
      padding: '10px 20px',
      borderRadius: '5px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between', // To place the 'x' on the right
      minWidth: '200px', // Ensure some space for the message and the 'x' button
      ...getToastStyle(),
    }}>
      <span>{message}</span>
      <button 
        onClick={onClose} 
        style={{
          background: 'transparent',
          border: 'none',
          color: '#fff',
          fontSize: '16px',
          cursor: 'pointer',
          marginLeft: '10px',
        }}
      >
        &times;
      </button>
    </div>
  );
};

export default Toast;



